/* eslint-disable */
import libraries from '../arduino/libraries'

export default function init(Blockly, profile) {
    Blockly.Arduino.blynk = {};

    function blynkserial_varDef(a, b) {
        var c = "SoftwareSerial blynk_esp01_serial(" + b + "," + a + ");";
        0 == b && 1 == a && (c = "HardwareSerial &blynk_esp01_serial=Serial;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n");
        // Arduino Mega not implented
        // "Arduino Mega" == profile["default"].description && 
        //     (19 == b && 18 == a && 
        //         (c = "HardwareSerial &blynk_esp01_serial=Serial1;",  Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"), 
        //     17 == b && 16 == a && 
        //         (c = "HardwareSerial &blynk_esp01_serial=Serial2;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"), 
        //     15 == b && 14 == a && 
        //         (c = "HardwareSerial &blynk_esp01_serial=Serial3;", Blockly.Arduino.definitions_.define_hardserial = "#include <HardwareSerial.h>\n"));
        return c;
    }

    function setupBlynk(a, b, c) {
        "" != a && (Blockly.Arduino.definitions_.blynk_contype = "\n// Blynk for device: " + a);

        "esp01" == a && (Blockly.Arduino.definitions_.define_softserial = "#include <SoftwareSerial.h>\n",
                         Blockly.Arduino.definitions_.define_blynk = "#include \"ESP8266_Lib.h\"\n#include \"BlynkSimpleShieldEsp8266.h\"\n",
                         Blockly.Arduino.definitions_.var_blynk_esp01 = blynkserial_varDef(b, c) + "\nESP8266 blynk_esp01(&blynk_esp01_serial);");

        Blockly.Arduino.definitions_.var_blynk_auth || (Blockly.Arduino.definitions_.var_blynk_auth = 'char blynk_auth[] = "";');
        Blockly.Arduino.loops_.loop_blynk = "  Blynk.run();\n";
        Blockly.Arduino.definitions_.var_blynk_esp01 && (Blockly.Arduino.loops_.loop_blynk = "  blynk_esp01_serial.listen();\n  Blynk.run();");
        (a = Blockly.Arduino.definitions_.var_blynk_esp01) && a.startsWith("HardwareSerial") && (Blockly.Arduino.loops_.loop_blynk = "  Blynk.run();\n")
    }

    Blockly.Arduino.blynk_init_esp01 = function() {
        var a = Blockly.Arduino.quote_(this.getFieldValue("WIFINAME")),
            b = Blockly.Arduino.quote_(this.getFieldValue("WIFIPASS")),
            c = Blockly.Arduino.quote_(this.getFieldValue("AUTH")),
            d = this.getFieldValue("SERVER1"),
            e = this.getFieldValue("SERVER2"),
            f = this.getFieldValue("SERVER3"),
            g = this.getFieldValue("SERVER4"),
            h = this.getFieldValue("PORT"),
            k = this.getFieldValue("BAUD"),
            l = this.getFieldValue("RX"),
            m = this.getFieldValue("TX");
        Blockly.Arduino.definitions_.var_blynk_wifi_ssid = "const char blynk_wifi_ssid[] = " +
            a + ";";
        Blockly.Arduino.definitions_.var_blynk_wifi_pass = "const char blynk_wifi_pass[] = " + b + ";";
        Blockly.Arduino.definitions_.var_blynk_auth = "const char blynk_auth[] = " + c + ";";
        setupBlynk("esp01", l, m, k);
        a = "  Blynk.begin(blynk_auth, blynk_esp01, blynk_wifi_ssid, blynk_wifi_pass);\n";
        if ("0" != d || "0" != e || "0" != f || "0" != g) a = '  Blynk.begin(blynk_auth, blynk_esp01, blynk_wifi_ssid, blynk_wifi_pass, "' + d + "." + e + "." + f + "." + g + '",' + h + ");\n";
        Blockly.Arduino.setups_.setup_blynk = "  blynk_esp01_serial.begin(" + k + ");\n" + a;
        return ""
    };
    Blockly.Arduino.blynk_vpin_write = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "";
        return "Blynk.virtualWrite(" + a + ", " + b + ");\n"
    };
    Blockly.Arduino.blynk_set_property = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.valueToCode(this, "PROPERTY", Blockly.Arduino.ORDER_ATOMIC) || "",
            c = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC) || "";
        return "Blynk.setProperty(" + a + ", " + b + ", " + c + ");\n"
    };
    Blockly.Arduino.blynk_app_write = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.statementToCode(this, "DO");
        b = "BLYNK_WRITE(" + a + ") {\n" + (b + "}\n");
        Blockly.Arduino.definitions_fnc_["fnc_blynk_app_write_" + a] = b;
        return ""
    };
    Blockly.Arduino.blynk_app_read = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.statementToCode(this, "DO");
        b = "BLYNK_READ(" + a + ") {\n" + (b + "}\n");
        Blockly.Arduino.definitions_fnc_["fnc_blynk_app_read_" + a] = b;
        return ""
    };
    Blockly.Arduino.blynk_param_read_int0 = function() {
        return ["param.asDouble()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.blynk_param_read_int = function() {
        var a = "param",
            b = this.getFieldValue("INDEX");
        0 <= b && (a += "[" + b + "]");
        return [a + ".asDouble()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.blynk_param_read_string0 = function() {
        return ["param.asStr()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.blynk_param_read_string = function() {
        var a = "param",
            b = this.getFieldValue("INDEX");
        0 <= b && (a += "[" + b + "]");
        return [a + ".asStr()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.blynk_app_connected = function() {
        var a = "BLYNK_APP_CONNECTED(){\n" + (Blockly.Arduino.statementToCode(this, "DO") + "}\n");
        Blockly.Arduino.definitions_fnc_.fnc_blynk_app_connected = a;
        return ""
    };
    Blockly.Arduino.blynk_app_disconnected = function() {
        var a = "BLYNK_APP_DISCONNECTED(){\n" + (Blockly.Arduino.statementToCode(this, "DO") + "}\n");
        Blockly.Arduino.definitions_fnc_.fnc_blynk_app_disconnected = a;
        return ""
    };
    Blockly.Arduino.blynk_connected = function() {
        var a = "BLYNK_CONNECTED(){\n" + (Blockly.Arduino.statementToCode(this, "DO") + "}\n");
        Blockly.Arduino.definitions_fnc_.fnc_blynk_connected = a;
        return ""
    };
    Blockly.Arduino.blynk_led = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.valueToCode(this, "INTENSITY", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = "blynk_led_intensity_" + a;
        Blockly.Arduino.definitions_["var_" + c] = "WidgetLED " + c + "(" + a + ");";
        return c + ".setValue(" + b + ");\n"
    };
    Blockly.Arduino.blynk_led_onoff = function() {
        var a = this.getFieldValue("VPIN"),
            b = this.getFieldValue("STATE"),
            c = "blynk_led_onoff_" + a;
        Blockly.Arduino.definitions_["var_" + c] = "WidgetLED " + c + "(" + a + ");";
        a = "";
        "on" == b && (a = c + ".on();\n");
        "off" == b && (a = c + ".off();\n");
        return a
    };
    Blockly.Arduino.blynk_terminal_print = function() {
        var a = this.getFieldValue("VPIN"),
            b = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''",
            c = this.getFieldValue("NEWLINE"),
            d = "blynk_terminal_" + a;
        Blockly.Arduino.definitions_["var_blynk_terminal_" + a] = "WidgetTerminal " + d + "(" + a + ");";
        return "TRUE" == c ? d + ".println(" + b + ");\n" + d + ".flush(); \n" : d + ".print(" + b + "); " + d + ".flush(); \n"
    };
    Blockly.Arduino.blynk_terminal_clear = function() {
        var a = this.getFieldValue("VPIN"),
            b = "blynk_terminal_" + a;
        Blockly.Arduino.definitions_["var_blynk_terminal_" + a] = "WidgetTerminal " + b + "(" + a + ");";
        return b + ".clear();\n"
    };
    Blockly.Arduino.blynk_lcd_print = function() {
        var a = this.getFieldValue("VPIN"),
            b = this.getFieldValue("CURSOR_COLUMN"),
            c = this.getFieldValue("CURSOR_ROW"),
            d = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            e = "blynk_lcd_" + a;
        Blockly.Arduino.definitions_["var_blynk_lcd_" + a] = "WidgetLCD " + e + "(" + a + ");";
        return e + ".print(" + b + "," + c + "," + d + ");\n"
    };
    Blockly.Arduino.blynk_lcd_clear = function() {
        var a = this.getFieldValue("VPIN"),
            b = "blynk_lcd_" + a;
        Blockly.Arduino.definitions_["var_blynk_lcd_" + a] = "WidgetLCD " + b + "(" + a + ");";
        return b + ".clear();\n"
    };
    Blockly.Arduino.blynk_timer = function() {
        var a = this.getFieldValue("PERIOD"),
            b = Blockly.Arduino.statementToCode(this, "DO");
        Blockly.Arduino.definitions_["var_blynk_timer_" + a] = "BlynkTimer blynk_timer_" + a + ";";
        Blockly.Arduino.setups_["setup_blynk_timer_" + a] = "  blynk_timer_" + a + ".setInterval(" + a + "L, fnc_blynk_timer_" + a + ");\n";
        Blockly.Arduino.loops_["  loop_blynk_timer_" + a] = "blynk_timer_" + a + ".run();\n";
        b = "void fnc_blynk_timer_" + a + "(){\n" + (b + "\n}\n");
        Blockly.Arduino.definitions_fnc_["fnc_blynk_timer_" + a] = b;
        return ""
    };
    Blockly.Arduino.blynk_map = function() {
        var a = this.getFieldValue("VPIN"),
            b = this.getFieldValue("INDEX"),
            c = Blockly.Arduino.valueToCode(this, "LAT", Blockly.Arduino.ORDER_ATOMIC) || "0",
            d = Blockly.Arduino.valueToCode(this, "LON", Blockly.Arduino.ORDER_ATOMIC) || "0",
            e = Blockly.Arduino.valueToCode(this, "DESCRIPTION", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''",
            f = "blynk_map_" + a;
        Blockly.Arduino.definitions_["var_" + f] = "WidgetMap " + f + "(" + a + ");";
        return f + ".location(" + b + ", " + c + ", " + d + ", " + e + ");\n"
    };
}